module.exports = __webpack_public_path__ + "bf643df89cfbabf88b441e74560ad5ed.woff";